import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;

	img {
		position: absolute;
		top: 50%;
		right: 20px;
		transform: translateY(-50%);
		transition:
			filter 0.3s ease,
			opacity 0.3s ease;
		opacity: 0.5;
		user-select: none;
		pointer-events: none;
	}

	&:hover {
		img {
			opacity: 1;
			filter: invert(100%);
		}
	}
`;

export { StyledContainer };
